const Loading = ({ text = 'Loading...' }) => {
  return (
    <div className="loading-container">
      <div className="loading-wrapper">
        <div className="luxury-loading">
          <div className="loading-circle"></div>
          <div className="loading-circle"></div>
          <div className="loading-circle"></div>
        </div>
        <p className="loading-text">{text}</p>
      </div>
    </div>
  );
};

export default Loading;
